import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { useOffer } from '../contexts/OfferContext';

// Aparece después del hero y se oculta mientras alguna caja de precio está en pantalla.
export const StickyMobileCta = () => {
  const {
    secondsLeft,
    expired,
    priceLabel
  } = useOffer();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    const cards = document.querySelectorAll('[data-price-card]');
    let heroVisible = true;
    const visibleCards = new Set<Element>();
    const update = () => setVisible(!heroVisible && visibleCards.size === 0);
    const heroObserver = new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      update();
    });
    const cardObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) visibleCards.add(e.target);else visibleCards.delete(e.target);
      });
      update();
    });
    if (hero) heroObserver.observe(hero);
    cards.forEach(c => cardObserver.observe(c));
    return () => {
      heroObserver.disconnect();
      cardObserver.disconnect();
    };
  }, []);
  const mm = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const ss = (secondsLeft % 60).toString().padStart(2, '0');
  return <AnimatePresence data-id="element-250" data-mp="1qs8xfpvx9zr9">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-familia-dark border-t border-familia-darkBorder px-3 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] flex items-center gap-3" data-id="element-251" data-mp="1qtak6rmawaot">
          <div className="flex items-center gap-1.5 bg-familia-darkCard border border-familia-urgent/60 rounded-lg px-2.5 h-[52px] shrink-0" role="timer" aria-label={expired ? 'Reserva vencida' : `Reserva vence en ${mm}:${ss}`} data-id="element-252" data-mp="3b6j9kv95lc1t">
            <ClockIcon className="w-4 h-4 text-familia-urgent" aria-hidden="true" data-id="element-253" data-mp="14hze1n70tz3y" />
            <span className="font-mono font-bold text-[15px] text-familia-urgent tabular-nums" data-id="element-254" data-mp="19asie9ykv5fi">
              {expired ? '00:00' : `${mm}:${ss}`}
            </span>
          </div>
          <a href="#precio" className="flex-1 inline-flex items-center justify-center h-[52px] rounded-lg bg-familia-cta hover:bg-familia-ctaHover text-familia-ctaInk font-bold uppercase text-[15px] whitespace-nowrap transition-colors duration-150 ease-out" data-id="element-255" data-mp="zjftnr82svdp">
            QUIERO EL KIT — {priceLabel}
          </a>
        </motion.div>}
    </AnimatePresence>;
};